export enum PrizeBoxErrorType {
  Paused = 'Paused',
  InsufficientPoints = 'InsufficientPoints',
  CallCountExceeded = 'CallCountExceeded',
  WALLET_UNAVAILABLE = 'WALLET_UNAVAILABLE',
  ContractUnreadable = 'ContractUnreadable',
  NeedTopUp = 'NeedTopUp',
  InsufficientGasForApprove = 'InsufficientGasForApprove',
  DoNotNeedToRestore = 'DoNotNeedToRestore',
  TokenAddressUnavailable = 'TokenAddressUnavailable',
  InsufficientTokenBalance = 'InsufficientTokenBalance',
  InsufficientGasForRestore = 'InsufficientGasForRestore',
  TransactionReverted = 'TransactionReverted',
  InvalidMove = 'InvalidMove',
  FailedToRestore = 'FailedToRestore',
  Unknown = 'Unknown',
}

export const PrizeBoxError = (type: PrizeBoxErrorType, message?: string) => {
  const error = new Error(message || type);
  error.name = 'PrizeBoxError';
  (error as any).type = type;
  return error as Error & { type: PrizeBoxErrorType };
};
